<template lang="pug">
div
  b-card
    b-row.mb-2
      b-col(md="6")
        h4.mb-0
          feather-icon(icon="BarChart2Icon" size="20" class="mr-50")
          | Indicadores de Privacidad

      b-col(md="6" class="text-right")
        b-button(
          variant="outline-warning"
          size="sm"
          @click="handleExportPDF"
          :disabled="isLoading || isExportingPDF"
        )
          b-spinner.mr-50(v-if="isExportingPDF" small)
          feather-icon(v-else icon="FileTextIcon" class="mr-50")
          | Exportar PDF

  div(v-if="isLoading")
    b-card
      .text-center.py-5
        b-spinner(variant="primary")
        p.mt-2 Cargando indicadores...

  div(v-else ref="dashboardContainer")
    //- KPIs de Gestión
    b-card(no-body)
      b-card-body
        .d-flex.justify-content-between.align-items-center.mb-2
          h5.mb-0
            feather-icon(icon="SettingsIcon" size="18" class="mr-50")
            | KPIs de Gestión
          b-button(
            variant="outline-grey"
            size="sm"
            @click="toggleAllGestion"
          )
            feather-icon(:icon="allGestionExpanded ? 'ChevronUpIcon' : 'ChevronDownIcon'" size="14" class="mr-25")
            | {{ allGestionExpanded ? 'Colapsar todo' : 'Desplegar todo' }}

        b-row
          b-col(
            v-for="kpi in kpisGestion"
            :key="kpi.key"
            md="6"
            class="mb-1"
          )
            kpi-card(
              :title="kpi.title"
              :value="kpi.value"
              :target="kpi.target"
              :status="kpi.status"
              :unit="kpi.unit"
              :items="getDrilldownData(kpi.key)"
              :fields="getKpiFields(kpi.key)"
              :expanded.sync="expandedGestion[kpi.key]"
            )

    //- Indicadores de Objetivo
    b-card(no-body)
      b-card-body
        .d-flex.justify-content-between.align-items-center.mb-2
          h5.mb-0
            feather-icon(icon="TargetIcon" size="18" class="mr-50")
            | Indicadores de Objetivo
          b-button(
            variant="outline-grey"
            size="sm"
            @click="toggleAllObjetivo"
          )
            feather-icon(:icon="allObjetivoExpanded ? 'ChevronUpIcon' : 'ChevronDownIcon'" size="14" class="mr-25")
            | {{ allObjetivoExpanded ? 'Colapsar todo' : 'Desplegar todo' }}

        b-row
          b-col(
            v-for="kpi in kpisObjetivo"
            :key="kpi.key"
            md="6"
            class="mb-1"
          )
            kpi-card(
              :title="kpi.title"
              :value="kpi.value"
              :target="kpi.target"
              :status="kpi.status"
              :unit="kpi.unit"
              :items="getDrilldownData(kpi.key)"
              :fields="getKpiFields(kpi.key)"
              :expanded.sync="expandedObjetivo[kpi.key]"
            )

    //- Indicadores de Resultados (oculto a pedido del cliente, no eliminar)
    b-card(no-body v-if="false")
      b-card-body
        h5.mb-2
          feather-icon(icon="ActivityIcon" size="18" class="mr-50")
          | Indicadores de Resultados

        b-row
          b-col(
            v-for="kpi in kpisResultados"
            :key="kpi.key"
            md="4"
            lg="3"
            class="mb-1"
          )
            b-card.text-center.result-card(no-body)
              b-card-body
                h3.mb-25.font-weight-bold {{ kpi.value }}
                p.mb-0.small {{ kpi.title }}

    //- Gráficos
    b-row
      //- Dona: Tratamientos por nivel de riesgo
      b-col(md="6")
        b-card
          b-card-title Tratamientos por Nivel de Riesgo
          vue-apex-charts(
            v-if="donutRiskData.values.some(v => v > 0)"
            type="donut"
            height="320"
            :options="donutOptions"
            :series="donutRiskData.values"
          )
          p.text-center.text-muted(v-else) Sin datos disponibles

      //- Barras: Estado de planes ARR
      b-col(md="6")
        b-card
          b-card-title Estado de Planes de Acción
          vue-apex-charts(
            v-if="barPlanStatusData.values.some(v => v > 0)"
            type="bar"
            height="320"
            :options="barPlanOptions"
            :series="barPlanSeries"
          )
          p.text-center.text-muted(v-else) Sin datos disponibles

    b-row
      //- Barras: Cumplimiento GAP por obligación
      b-col(cols="12")
        b-card
          b-card-title Cumplimiento GAP por Obligación
          vue-apex-charts(
            v-if="barGapComplianceData.labels.length > 0"
            type="bar"
            height="350"
            :options="barGapOptions"
            :series="barGapSeries"
          )
          p.text-center.text-muted(v-else) Sin datos disponibles

    //- Indicadores ARSOPB+L
    b-card(no-body)
      b-card-body
        h5.mb-2
          feather-icon(icon="MessageSquareIcon" size="18" class="mr-50")
          | Canal ARSOPB+L

        b-row
          b-col(
            v-for="kpi in arsopblKpis"
            :key="kpi.key"
            md="4"
            class="mb-1"
          )
            b-card.text-center.result-card(no-body)
              b-card-body
                h3.mb-25.font-weight-bold {{ kpi.value }}{{ kpi.unit }}
                p.mb-0.small {{ kpi.title }}

    b-row
      //- Barras: Solicitudes por mes
      b-col(md="7")
        b-card
          b-card-title Solicitudes por Mes
          vue-apex-charts(
            v-if="arsopblByMonth.values.some(v => v > 0)"
            type="bar"
            height="320"
            :options="arsopblMonthOptions"
            :series="arsopblMonthSeries"
          )
          p.text-center.text-muted(v-else) Sin datos disponibles

      //- Dona: Distribución por derecho
      b-col(md="5")
        b-card
          b-card-title Distribución por Derecho
          vue-apex-charts(
            v-if="arsopblByRight.values.some(v => v > 0)"
            type="donut"
            height="320"
            :options="arsopblRightOptions"
            :series="arsopblByRight.values"
          )
          p.text-center.text-muted(v-else) Sin datos disponibles
</template>

<script>
import { ref, computed, onMounted } from '@vue/composition-api'
import { BCardTitle, BSpinner, BCardBody } from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import KpiCard from '../components/KPICard.vue'
import useIndicators from './useIndicators'

const KPI_FIELDS_MAP = {
  rat_coverage: [
    { key: 'treatmentId', label: 'ID', sortable: true },
    { key: 'nombre', label: 'Nombre', sortable: true },
    { key: 'actions', label: '' },
  ],
  ari_completed: [
    { key: 'treatmentId', label: 'ID', sortable: true },
    { key: 'nombre', label: 'Nombre', sortable: true },
    { key: 'ariStatus', label: 'Tiene ARI', sortable: true },
    { key: 'actions', label: '' },
  ],
  eipd_required: [
    { key: 'treatmentId', label: 'ID', sortable: true },
    { key: 'nombre', label: 'Nombre', sortable: true },
    { key: 'actions', label: '' },
  ],
  high_risk_pct: [
    { key: 'treatmentId', label: 'ID', sortable: true },
    { key: 'nombre', label: 'Nombre', sortable: true },
    { key: 'level', label: 'Nivel', sortable: true },
    { key: 'risk', label: 'Riesgo', sortable: true },
    { key: 'actions', label: '' },
  ],
  avg_inherent: [
    { key: 'treatmentId', label: 'ID', sortable: true },
    { key: 'nombre', label: 'Nombre', sortable: true },
    { key: 'level', label: 'Nivel', sortable: true },
    { key: 'risk', label: 'Riesgo', sortable: true },
    { key: 'actions', label: '' },
  ],
  avg_residual: [
    { key: 'treatmentId', label: 'ID', sortable: true },
    { key: 'nombre', label: 'Nombre', sortable: true },
    { key: 'level', label: 'Nivel', sortable: true },
    { key: 'risk', label: 'Riesgo', sortable: true },
    { key: 'actions', label: '' },
  ],
  risk_reduction: [
    { key: 'treatmentId', label: 'ID', sortable: true },
    { key: 'nombre', label: 'Nombre', sortable: true },
    { key: 'inherentRisk', label: 'R. Inherente', sortable: true },
    { key: 'residualRisk', label: 'R. Residual', sortable: true },
    { key: 'actions', label: '' },
  ],
  transfers: [
    { key: 'treatmentId', label: 'ID', sortable: true },
    { key: 'nombre', label: 'Nombre', sortable: true },
    { key: 'destinatario', label: 'Destinatario', sortable: true },
    { key: 'actions', label: '' },
  ],
  sensitive: [
    { key: 'treatmentId', label: 'ID', sortable: true },
    { key: 'nombre', label: 'Nombre', sortable: true },
    { key: 'actions', label: '' },
  ],
  minors: [
    { key: 'treatmentId', label: 'ID', sortable: true },
    { key: 'nombre', label: 'Nombre', sortable: true },
    { key: 'actions', label: '' },
  ],
  gap_compliance: [
    { key: 'nombre', label: 'Obligación', sortable: true },
    { key: 'status', label: 'Estado', sortable: true },
    { key: 'planStatus', label: 'Estado Plan', sortable: true },
    { key: 'actions', label: '' },
  ],
  no_breach: [
    { key: 'nombre', label: 'Obligación', sortable: true },
    { key: 'status', label: 'Estado', sortable: true },
    { key: 'planStatus', label: 'Estado Plan', sortable: true },
    { key: 'actions', label: '' },
  ],
  closed_plans: [
    { key: 'nombre', label: 'Obligación', sortable: true },
    { key: 'status', label: 'Estado', sortable: true },
    { key: 'planStatus', label: 'Estado Plan', sortable: true },
    { key: 'deadline', label: 'Plazo', sortable: true },
    { key: 'actions', label: '' },
  ],
}

const DEFAULT_KPI_FIELDS = [
  { key: 'nombre', label: 'Nombre', sortable: true },
  { key: 'actions', label: '' },
]

export default {
  name: 'IndicatorsList',
  components: {
    BCardTitle,
    BSpinner,
    BCardBody,
    VueApexCharts,
    KpiCard,
  },
  setup() {
    const {
      isLoading,
      kpisGestion,
      kpisObjetivo,
      kpisResultados,
      donutRiskData,
      barPlanStatusData,
      barGapComplianceData,
      arsopblKpis,
      arsopblByMonth,
      arsopblByRight,
      getDrilldownData,
      fetchData,
    } = useIndicators()

    const isExportingPDF = ref(false)
    const dashboardContainer = ref(null)

    const getKpiFields = (key) => KPI_FIELDS_MAP[key] || DEFAULT_KPI_FIELDS

    const buildExpandedState = (kpiList) => {
      const state = {}
      kpiList.forEach(kpi => { state[kpi.key] = false })
      return state
    }

    const expandedGestion = ref(buildExpandedState(kpisGestion.value))
    const expandedObjetivo = ref(buildExpandedState(kpisObjetivo.value))

    const allGestionExpanded = computed(() => Object.values(expandedGestion.value).every(Boolean))
    const allObjetivoExpanded = computed(() => Object.values(expandedObjetivo.value).every(Boolean))

    const toggleAllGestion = () => {
      const next = !allGestionExpanded.value
      Object.keys(expandedGestion.value).forEach(key => { expandedGestion.value[key] = next })
    }

    const toggleAllObjetivo = () => {
      const next = !allObjetivoExpanded.value
      Object.keys(expandedObjetivo.value).forEach(key => { expandedObjetivo.value[key] = next })
    }

    // Chart options
    const donutOptions = computed(() => ({
      labels: donutRiskData.value.labels,
      colors: donutRiskData.value.colors,
      legend: { show: true, position: 'bottom', fontSize: '13px', fontFamily: 'Montserrat' },
      dataLabels: {
        enabled: true,
        formatter(val) { return `${Math.round(val)}%` },
      },
      plotOptions: {
        pie: {
          donut: {
            labels: {
              show: true,
              name: { fontSize: '1.5rem', fontFamily: 'Montserrat' },
              value: { fontSize: '1.2rem', fontFamily: 'Montserrat' },
              total: { show: true, fontSize: '1.2rem', label: 'Total', color: '#373d3f' },
            },
          },
        },
      },
      responsive: [{ breakpoint: 576, options: { chart: { height: 280 }, legend: { show: true } } }],
    }))

    const barPlanOptions = computed(() => ({
      chart: { toolbar: { show: false } },
      plotOptions: { bar: { horizontal: false, columnWidth: '50%', borderRadius: 4, distributed: true } },
      colors: barPlanStatusData.value.colors,
      xaxis: { categories: barPlanStatusData.value.labels },
      yaxis: { labels: { formatter: (val) => Math.floor(val) === val ? val : '' }, forceNiceScale: true },
      dataLabels: { enabled: true },
      legend: { show: false },
    }))

    const barPlanSeries = computed(() => [{
      name: 'Cantidad',
      data: barPlanStatusData.value.values,
    }])

    const barGapOptions = computed(() => ({
      chart: { toolbar: { show: false }, stacked: true },
      plotOptions: { bar: { horizontal: true, barHeight: '60%', borderRadius: 3 } },
      colors: ['#70AD47', '#FFC000', '#C00000', '#CCCCCC'],
      xaxis: {
        categories: barGapComplianceData.value.labels.map(l => l.length > 30 ? `${l.substring(0, 30)}...` : l),
        labels: { formatter: (val) => Math.floor(val) === val ? val : '' },
        crosshairs: { width: 1 },
      },
      dataLabels: { enabled: false },
      legend: { show: true, position: 'top' },
      tooltip: { shared: true, intersect: false, followCursor: true, y: { formatter: (val) => Math.round(val) } },
    }))

    const barGapSeries = computed(() => {
      const data = barGapComplianceData.value.data
      const labels = barGapComplianceData.value.labels
      return [
        { name: 'Implementado', data: labels.map(l => data[l]?.Implementado || 0) },
        { name: 'Parcial', data: labels.map(l => data[l]?.Parcial || 0) },
        { name: 'No implementado', data: labels.map(l => data[l]?.['No implementado'] || 0) },
        { name: 'No aplica', data: labels.map(l => data[l]?.['No aplica'] || 0) },
      ]
    })

    // ARSOPB+L: Solicitudes por mes (barras)
    const arsopblMonthOptions = computed(() => ({
      chart: { toolbar: { show: false } },
      plotOptions: { bar: { horizontal: false, columnWidth: '55%', borderRadius: 4 } },
      colors: ['#498ceb'],
      xaxis: { categories: arsopblByMonth.value.labels },
      yaxis: { labels: { formatter: (val) => Math.floor(val) === val ? val : '' }, forceNiceScale: true },
      dataLabels: { enabled: true },
      legend: { show: false },
    }))

    const arsopblMonthSeries = computed(() => [{
      name: 'Solicitudes',
      data: arsopblByMonth.value.values,
    }])

    // ARSOPB+L: Distribución por derecho (dona)
    const arsopblRightOptions = computed(() => ({
      labels: arsopblByRight.value.labels,
      colors: arsopblByRight.value.colors,
      legend: { show: true, position: 'bottom', fontSize: '13px', fontFamily: 'Montserrat' },
      dataLabels: { enabled: true, formatter(val) { return `${Math.round(val)}%` } },
      plotOptions: {
        pie: {
          donut: {
            labels: {
              show: true,
              name: { fontSize: '1.5rem', fontFamily: 'Montserrat' },
              value: { fontSize: '1.2rem', fontFamily: 'Montserrat' },
              total: { show: true, fontSize: '1.2rem', label: 'Total', color: '#373d3f' },
            },
          },
        },
      },
      responsive: [{ breakpoint: 576, options: { chart: { height: 280 }, legend: { show: true } } }],
    }))

    const handleExportPDF = async () => {
      const container = dashboardContainer.value
      if (!container) return

      isExportingPDF.value = true
      try {
        const html2canvas = (await import('html2canvas')).default
        const { jsPDF } = await import('jspdf')

        // eslint-disable-next-line new-cap
        const pdf = new jsPDF('p', 'mm', 'a4')
        const pageWidth = pdf.internal.pageSize.getWidth()
        const pageHeight = pdf.internal.pageSize.getHeight()
        const margin = 10
        const usableWidth = pageWidth - (margin * 2)

        const sections = container.querySelectorAll(':scope > .card, :scope > .row')
        let currentY = margin

        for (let i = 0; i < sections.length; i++) {
          const section = sections[i]
          const canvas = await html2canvas(section, { backgroundColor: '#ffffff', scale: 2 })
          const imgData = canvas.toDataURL('image/png')
          const imgHeight = (canvas.height * usableWidth) / canvas.width

          if (currentY + imgHeight > pageHeight - margin && currentY > margin) {
            pdf.addPage()
            currentY = margin
          }

          pdf.addImage(imgData, 'PNG', margin, currentY, usableWidth, imgHeight)
          currentY += imgHeight + 5
        }

        pdf.save(`Indicadores_Privacidad_${new Date().toISOString().slice(0, 10)}.pdf`)
      } catch (error) {
        console.log('Error exportando PDF:', error)
      } finally {
        isExportingPDF.value = false
      }
    }

    onMounted(() => {
      fetchData()
    })

    return {
      isLoading,
      isExportingPDF,
      kpisGestion,
      kpisObjetivo,
      kpisResultados,
      donutRiskData,
      barPlanStatusData,
      barGapComplianceData,
      dashboardContainer,
      getDrilldownData,
      getKpiFields,
      expandedGestion,
      expandedObjetivo,
      allGestionExpanded,
      allObjetivoExpanded,
      toggleAllGestion,
      toggleAllObjetivo,
      donutOptions,
      barPlanOptions,
      barPlanSeries,
      barGapOptions,
      barGapSeries,
      arsopblKpis,
      arsopblByMonth,
      arsopblByRight,
      arsopblMonthOptions,
      arsopblMonthSeries,
      arsopblRightOptions,
      handleExportPDF,
    }
  },
}
</script>

<style lang="scss" scoped>
.result-card {
  border: 1px solid #ebe9f1;
  border-radius: 6px;
  transition: box-shadow 0.2s;

  &:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  }
}
</style>
